import React from "react";

import { faMagnifyingGlass } from "@performyard/fontawesome/pro-regular-svg-icons";

import { Icon } from "../../Icon";

export const IconDefault = () => {
	return <Icon icon={faMagnifyingGlass} size={24} color="neutral-5" />;
};
